<template>
  <a-month-picker
    @change="(e)=>findEvent({e})"
    v-bind="$attrs.item"
    v-model="modelList[name]"
  />
</template>

<script>
import formMixin from "@/minxin/form.mixin.js";
import { DatePicker } from "ant-design-vue";
import Vue from 'vue'
Vue.use(DatePicker)
export default {
  mixins: [formMixin],
  props: {
    name: {},
    modelList: {},
    funcList: {},
  },
};
</script>
